/**
 * Nombres cortos de los pasos de la carga inicial, en el orden de la guía del
 * administrador (ver onboardingSteps.js). Las claves tienen que coincidir con
 * CondominiumOnboardingService::ACTIVATION_STEPS en el backend.
 */
export const ADOPTION_STEP_LABELS = {
  owners: 'Propietarios',
  aliquot: 'Alícuotas',
  balances: 'Saldos iniciales',
  expenses: 'Gastos ordinarios',
  periods: 'Períodos',
};

/** Etapas del embudo, como las entiende /report/indicators/adoption/condominiums. */
export const ADOPTION_STAGE_LABELS = {
  onboarding: 'carga inicial completa',
  planilla: 'planilla emitida',
  active_owners: 'propietarios activos',
  payments: 'pagos reportados',
};
